<template>
<div class="row">
    <div class="col-12 col-md-10 offset-md-1">
        <div class="row">
            <div class="col-xl-4 col-12 mb-3">
                <div class="card">
                    <div class="card-header blue-gradient">Crear sub-categorías agenda</div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="name">Nombre</label>
                            <input type="text" class="form-control" placeholder="Nombre de la sub-categoría" v-model="subcategory.name">
                        </div>

                        <div class="form-group-dates">
                            <div v-for="(dateGroup, iDate) in subcategory.dates" :key="iDate" class="group-date">
                                <hr class="mt-4 mb-3" v-if="iDate > 0">

                                <div class="row">
                                    <div v-bind:class="{ 'col-md': (iDate > 0)}" class="col-12">
                                        <div class="form-group">
                                            <label for="name">Fecha</label>
                                            <input type="date" class="form-control" placeholder="Nombre de la nueva área" v-model="dateGroup.date">
                                        </div>
                                        <div class="form-group">
                                            <label for="name">Hora</label>
                                            <input type="time" class="form-control" placeholder="Nombre de la nueva área" v-model="dateGroup.time">
                                        </div>
                                    </div>
                                    <div v-if="iDate > 0" class="col-auto">
                                        <button class="btn btn-danger btn-sm btn-delete-dates" type="button" @click="deleteDate(iDate)">X</button>
                                    </div>
                                </div>

                            </div>
                            
                            <button class="btn btn-info mt-4 mb-4 btn-sm btn-block" type="button" @click.prevent="addDate">Agregar fecha</button>
                        </div>
                        <div class="form-group">
                            <label for="name">Categoria</label>

                            <select class="form-control" name="" id="" v-model="subcategory.category_id">
                                <option value="">Seleccionar categoría</option>
                                <option v-for="category in categories" :value="category.id" :key="category.id">{{category.name}}</option>
                            </select>
                        </div>

                        <input class="btn btn-primary" type="button" value="Guardar" @click.prevent="storeScheduleSubcategory">
                    </div>
                </div>
            </div>
            <div class="col-xl-8 col-12">
                <div class="card">
                    <div class="card-header green-gradient">Sub-categorías creadas</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="subcategories-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Categoria</th>
                                    <th>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(currentSubcategory, i) in subcategories" :key="currentSubcategory.id">
                                    <td>{{currentSubcategory.id}}</td>
                                    <td>{{currentSubcategory.name}}</td>
                                    <td>{{currentSubcategory.date_format}}</td>
                                    <td>{{currentSubcategory.time_format}}</td>
                                    <td>{{currentSubcategory.category.name}}</td>
                                    <td width="50px">
                                        <input type="button" value="✕" class="btn btn-danger btn-sm" @click="deleteSubcategory(currentSubcategory, i)">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
        
</template>
<script>
export default {
    name: 'cities',
    mounted: function(){
        this.fetchCategories();
        this.fetchSubcategories();
    },
    data(){
        return {
            baseUrl: process.env.VUE_APP_API,
            categories: [],
            subcategories: [],
            subcategory: {
                name: '',
                dates: [
                    {
                        date: '',
                        time: '',    
                    }
                ],
                date: '',
                time: '',
                category_id: '',
            },
            table: null
        }
    },
    methods: {
        fetchCategories: function(){
            let _this = this;
            this.$http.get(
                `${this.baseUrl}/admin/schedules-categories`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.categories = data.body.data;
            })
            .catch(error => {
            });
        },
        fetchSubcategories: function(){
            let _this = this;
            let loader = this.$loading.show();
            this.$http.get(
                `${this.baseUrl}/admin/schedules-subcategories`, 
                {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
            .then(data => {
                _this.subcategories = data.body.data;
                var subcategoriesTable = $("#subcategories-table");
                window.setTimeout(()=>{this.renderTable(subcategoriesTable)}, 0);
                loader.hide();
            })
            .catch(error => {
                console.log(error.error);
                loader.hide();
            });
        },
        addDate: function() {
            this.subcategory.dates.push({
                date: '',
                time: '', 
            });
        },
        storeScheduleSubcategory: function(){
            if(this.subcategory.name != "" && this.subcategory.category_id != ""){
                let loader = this.$loading.show();
                this.$http.post(
                    `${this.baseUrl}/admin/schedules-subcategories`, this.subcategory,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                .then(data => {
                    console.log(data);
                    this.fetchSubcategories();
                    loader.hide();
                    this.subcategory.name = "";
                    
                    window.location.reload();
                })
                .catch(() => {
                    loader.hide();
                });
            } else {
                this.$dialogs.alert("Se requiere completar todos los campos", {title: 'Error', size: 'sm'});
            }
        },
        deleteDate(i) {
            this.subcategory.dates.splice(i, 1);
        },
        deleteSubcategory(subcategory, i){
            let _this = this;
            this.$dialogs.confirm(`¿Desea borrar la sub-categoría con nombre ${subcategory.name}?`, {title: "Eliminar", size: "sm", okLabel: "Sí", cancelLabel: "Cancelar"})
            .then(response => {
                if(response.ok){
                    const loader = this.$loading.show();
                    const requestUrl = `${this.baseUrl}/admin/schedules-subcategories/${subcategory.id}`;
                    this.$http.delete(requestUrl,
                    {headers: {Authorization: `Bearer ${localStorage.getItem('session_id')}`}})
                    .then(() => {
                        this.$dialogs.alert("Sub-categoría borrada con éxito", {title: "Éxito", size: "sm"});
                        _this.subcategories.splice(i, 1);
                        loader.hide();
                    })
                    .catch(error => {
                        if(error.status == 409){
                            loader.hide();
                        }
                    });
                }
            });
        },
        renderTable(table){
            if(this.table != null){
                this.table.destroy();
            }

            this.table = table.DataTable({
                destroy: true,
                "language": {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }
    }

}
</script>
<style lang="scss" scoped>
    @import '../../assets/scss/colors';

    .form-group-dates{
        padding: 10px 10px;
        background: #eee;
    }

    .btn-delete-dates {
        margin-top: 70px;
    }

    hr {
        border-top-color: rgba(0,0,0,.2);
    }
</style>


